/* PRA Cosmetics - cart drawer (Reborn-style layout, brand colors):
   free-shipping progress bar, coupon row, checkout w/ total, continue link. */
(function () {
  var THRESHOLD = 29900; // ₪299 in agorot
  var enhancing = false;

  function money(c) {
    return '₪' + (c / 100).toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function inner() { return document.querySelector('#CartDrawer .drawer__inner'); }

  function ensureStyle() {
    if (document.getElementById('pra-cart-style')) return;
    var css = ''
      + 'cart-drawer .drawer__inner{width:min(470px,100vw)!important;max-width:100vw!important;background:var(--pra-cream,#F5F3F0)!important;}'
      + '@media(max-width:749px){cart-drawer .drawer__inner{width:100vw!important;}}'
      + '.drawer__header{padding:20px 22px 6px!important;}'
      + '.drawer__heading{font-family:Assistant,sans-serif!important;font-size:21px!important;font-weight:800!important;color:var(--pra-forest)!important;}'
      + '.pra-ship{padding:12px 22px 18px;}'
      + '.pra-ship__row{display:flex;align-items:center;gap:8px;margin-bottom:9px;font-family:Assistant,sans-serif;font-weight:700;font-size:14px;color:var(--pra-forest,#2E4A2B);}'
      + '.pra-ship__trophy{font-size:17px;line-height:1;}'
      + '.pra-ship__msg strong{font-weight:800;}'
      + '.pra-ship__track{height:9px;border-radius:999px;background:rgba(46,74,43,.13);overflow:hidden;}'
      + '.pra-ship__fill{height:100%;border-radius:999px;background:linear-gradient(90deg,var(--pra-emerald,#0E655B),var(--pra-forest,#2E4A2B));transition:width .55s cubic-bezier(.2,.7,.2,1);}'
      + '#CartDrawer .cart-item__name{font-family:Assistant,sans-serif!important;font-size:16px!important;font-weight:700!important;color:var(--pra-forest)!important;}'
      + '#CartDrawer .cart-item__price-wrapper .price,#CartDrawer .cart-item .product-option{font-size:15px!important;font-weight:700!important;color:var(--pra-forest)!important;}'
      + '#CartDrawer .quantity{border:1.5px solid rgba(46,74,43,.22)!important;background:#fff!important;border-radius:10px!important;gap:0!important;min-height:auto!important;overflow:hidden;}'
      + '#CartDrawer .quantity__button{border:none!important;border-radius:0!important;width:38px;height:40px;min-width:38px;color:var(--pra-forest)!important;background:#fff!important;}'
      + '#CartDrawer .quantity__button:hover{background:var(--pra-cream,#F5F3F0)!important;color:var(--pra-emerald)!important;}'
      + '#CartDrawer .quantity__input{width:34px;background:transparent;border:none;font-weight:700;color:var(--pra-forest);border-inline:1px solid rgba(46,74,43,.14);}'
      + '#CartDrawer thead{position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;}'
      + '#CartDrawer button.cart-remove-button{width:auto!important;height:auto!important;padding:2px 6px!important;text-decoration:underline;font-size:13px;color:#6b6660;font-weight:600;}'
      + '.pra-coupon{border-top:1px solid rgba(46,74,43,.12);}'
      + '.pra-coupon__toggle{display:flex;align-items:center;justify-content:space-between;width:100%;background:none;border:none;cursor:pointer;font-family:Assistant,sans-serif;font-weight:700;font-size:15px;color:var(--pra-forest,#2E4A2B);padding:14px 2px;}'
      + '.pra-coupon__chev{transition:transform .25s;font-size:13px;opacity:.7;}'
      + '.pra-coupon.is-open .pra-coupon__chev{transform:rotate(180deg);}'
      + '.pra-coupon__body{display:flex;gap:8px;padding:0 0 14px;}'
      + '.pra-coupon__body[hidden]{display:none;}'
      + '.pra-coupon__input{flex:1;min-width:0;border:1.5px solid rgba(46,74,43,.25);border-radius:10px;padding:12px;font-size:14px;font-family:Assistant,sans-serif;background:#fff;color:var(--pra-forest);}'
      + '.pra-coupon__apply{background:var(--pra-forest,#2E4A2B);color:#fff;border:none;border-radius:10px;padding:0 20px;font-weight:800;font-family:Assistant,sans-serif;cursor:pointer;}'
      + '.pra-coupon__apply:hover{background:var(--pra-emerald,#0E655B);}'
      + '.pra-empty-note{text-align:center;color:#6b6660;font-family:Assistant,sans-serif;font-size:15px;line-height:1.6;margin:6px 22px 0;}'
      + '#CartDrawer .totals__total{font-size:15px!important;color:#6b6660!important;}'
      + '#CartDrawer .totals__total-value{font-size:24px!important;font-weight:800!important;color:var(--pra-forest)!important;}'
      + '#CartDrawer .cart__ctas{display:flex!important;flex-direction:column;gap:8px;}'
      + '#CartDrawer-Checkout{display:flex!important;align-items:center;justify-content:center;gap:10px;width:100%;background:var(--pra-forest,#2E4A2B)!important;color:#fff!important;border:none!important;border-radius:999px!important;font-weight:800!important;font-size:1.08rem!important;padding:17px 10px!important;}'
      + '#CartDrawer-Checkout:hover{background:var(--pra-emerald,#0E655B)!important;}'
      + '#CartDrawer-Checkout svg{flex:0 0 auto;}'
      + '.pra-continue{display:block;width:100%;text-align:center;background:none;border:none;cursor:pointer;font-family:Assistant,sans-serif;font-weight:600;font-size:14.5px;color:#6b6660;padding:6px 4px;text-decoration:underline;}'
      + '.pra-continue:hover{color:var(--pra-forest,#2E4A2B);}';
    var st = document.createElement('style');
    st.id = 'pra-cart-style';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function renderShip(box, cart) {
    var rem = THRESHOLD - cart.total_price;
    var pct = Math.max(6, Math.min(100, Math.round((cart.total_price / THRESHOLD) * 100)));
    var msg = rem > 0
      ? 'עוד <strong>' + money(rem) + '</strong> ומשלוח חינם!'
      : 'מגיע לכם משלוח חינם! 🎉';
    box.innerHTML =
      '<div class="pra-ship__row"><span class="pra-ship__trophy">🏆</span><span class="pra-ship__msg">' + msg + '</span></div>' +
      '<div class="pra-ship__track"><div class="pra-ship__fill" style="width:' + pct + '%"></div></div>';
  }

  function buildCoupon(footer) {
    if (footer.querySelector('.pra-coupon')) return;
    var cp = document.createElement('div');
    cp.className = 'pra-coupon';
    cp.setAttribute('dir', 'rtl');
    cp.innerHTML =
      '<button type="button" class="pra-coupon__toggle">יש לך קוד קופון?<span class="pra-coupon__chev">▼</span></button>' +
      '<div class="pra-coupon__body" hidden>' +
      '<input type="text" class="pra-coupon__input" placeholder="הזינו קוד קופון" aria-label="קוד קופון">' +
      '<button type="button" class="pra-coupon__apply">החל</button></div>';
    footer.insertBefore(cp, footer.firstChild);
    var body = cp.querySelector('.pra-coupon__body');
    var inp = cp.querySelector('.pra-coupon__input');
    cp.querySelector('.pra-coupon__toggle').addEventListener('click', function () {
      var willOpen = body.hidden;
      body.hidden = !willOpen;
      cp.classList.toggle('is-open', willOpen);
      if (willOpen) inp.focus();
    });
    function apply() {
      var code = (inp.value || '').trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
    }
    cp.querySelector('.pra-coupon__apply').addEventListener('click', apply);
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
  }

  function enhance() {
    var box = inner();
    if (!box || enhancing) return;
    enhancing = true;

    getCart().then(function (cart) {
      var cnt = (cart && cart.item_count) || 0;
      var h = box.querySelector('.drawer__heading');
      var ht = cnt > 0 ? 'עגלת הקניות שלך (' + cnt + ')' : 'עגלת הקניות שלך';
      if (h && h.textContent.trim() !== ht) h.textContent = ht;

      if (!cart || cnt <= 0) {
        var et = box.querySelector('.cart__empty-text');
        if (et && et.textContent.indexOf('🌿') === -1) et.textContent = 'העגלה שלכם עוד ריקה 🌿';
        var ec = box.querySelector('.cart-drawer__empty-content');
        if (ec && !ec.querySelector('.pra-empty-note')) {
          var note = document.createElement('p');
          note.className = 'pra-empty-note';
          note.setAttribute('dir', 'rtl');
          note.textContent = 'בואו נמצא יחד את הפתרון המושלם בשבילכם';
          var firstBtn = ec.querySelector('a.button');
          if (firstBtn) ec.insertBefore(note, firstBtn); else ec.appendChild(note);
        }
        return;
      }

      var ship = box.querySelector('.pra-ship');
      if (!ship) {
        var hd = box.querySelector('.drawer__header');
        if (hd) {
          ship = document.createElement('div');
          ship.className = 'pra-ship';
          ship.setAttribute('dir', 'rtl');
          hd.parentNode.insertBefore(ship, hd.nextSibling);
        }
      }
      if (ship) renderShip(ship, cart);

      box.querySelectorAll('button.cart-remove-button').forEach(function (rb) {
        if (rb.textContent.trim() !== 'הסר') rb.textContent = 'הסר';
      });

      var footer = box.querySelector('.drawer__footer');
      if (footer) buildCoupon(footer);

      var co = box.querySelector('#CartDrawer-Checkout');
      if (co) {
        var svg = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"></path></svg>';
        co.innerHTML = svg + '<span>תשלום · ' + money(cart.total_price) + '</span>';
      }

      var ctas = box.querySelector('.cart__ctas');
      if (ctas && !ctas.querySelector('.pra-continue')) {
        var cont = document.createElement('button');
        cont.type = 'button';
        cont.className = 'pra-continue';
        cont.textContent = 'רוצה להמשיך בקניות?';
        cont.addEventListener('click', function () {
          var cd = document.querySelector('cart-drawer');
          if (cd && typeof cd.close === 'function') cd.close();
        });
        ctas.appendChild(cont);
      }
    }).catch(function () {}).finally(function () { enhancing = false; });
  }

  function boot() {
    ensureStyle();
    var cd = document.querySelector('#CartDrawer');
    if (!cd) return;
    enhance();
    var obs = new MutationObserver(function () {
      obs.disconnect();
      enhance();
      obs.observe(cd, { childList: true, subtree: true });
    });
    obs.observe(cd, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
